<template>
  <filtered-search
    :search-filters="searchFilters"
    :search-route="searchRoute"
    :place-holder="placeHolder"
    :model="model"
  >
    <template
      slot="results"
      slot-scope="{ items }"
    >
    <li
        v-for="(surgeon, index) in items"
        :key="surgeon.objectID"
        :class="{
            'border-t border-gray-200': index > 0
        }"
    >
        <a
            :href="surgeon.route"
            class="block transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus:bg-gray-50"
        >
            <div class="flex items-center px-4 py-4 sm:px-6">
                <div class="flex items-center flex-1 min-w-0">
                    <div class="flex-shrink-0">
                        <img
                            class="w-12 h-12 rounded-full"
                            :src="surgeon.thumbnail"
                            alt=""
                            loading="lazy"
                        >
                    </div>
                    <div class="flex-1 min-w-0 px-4 md:grid md:grid-cols-5 md:gap-4">
                        <div class="col-span-3 space-y-1">
                            <div class="flex space-x-2 text-sm font-semibold leading-5 text-blue-900 truncate hover:text-blue-700 lg:text-md visited:text-indigo-800">
                                <span v-html="surgeon.name_edge_ngram">
                                </span>
                                <span
                                    v-if="surgeon.primary_specialty"
                                    class="text-sm font-normal text-gray-600"
                                >
                                    {{ surgeon.primary_specialty }}
                                </span>
                                <span
                                    v-if="surgeon.npi"
                                    class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium leading-4 tracking-wide bg-gray-100 text-gray-800"
                                >
                                    NPI: {{ surgeon.npi }}
                                </span>
                            </div>
                            <div class="sm:flex">
                                <div
                                    v-if="surgeon.email"
                                    class="flex items-center mr-6 text-sm leading-5 text-gray-500"
                                >
                                    <svg
                                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                    </svg>
                                    <span class="truncate">
                                        {{ surgeon.email }}
                                    </span>
                                </div>
                                <div
                                    v-if="surgeon.city_state"
                                    class="flex items-center text-sm leading-5 text-gray-500 sm:mt-0"
                                >
                                    <svg
                                        class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                    >
                                        <path
                                            fill-rule="evenodd"
                                            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                            clip-rule="evenodd"
                                        />
                                    </svg>
                                    <p v-html="surgeon.city_state_edge_ngram"></p>
                                </div>

                            </div>
                        </div>
                        <div class="hidden col-span-2 md:block">
                            <div>
                                <div
                                    v-if="surgeon.primary_practice"
                                    class="flex items-center text-sm font-medium leading-5 text-gray-900 truncate"
                                >
                                    Primary Practice:
                                    <span
                                        class="ml-1 font-normal text-gray-500 truncate"
                                    >
                                        {{ surgeon.primary_practice }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <svg
                        class="w-5 h-5 text-gray-400"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </div>
            </div>
        </a>
      </li>
    </template>
  </filtered-search>
</template>

<script>
export default {
  props: {
    searchFilters: {
      type: [Array, Object],
      required: true,
    },
    searchRoute: {
      type: String,
      required: true,
    },
    placeHolder: {
        type: String,
        required: false,
        default: 'Search...'
    },
    model: {
        type: [Array, Object],
        required: true
    }
  },

  data: () => ({}),
};
</script>
